export default "__VITE_ASSET__DX6w6Gnx__"